import Masonry from 'masonry-layout';
var imagesLoaded = require('imagesloaded');

export default function MasonryGrid() {
  const grid = document.querySelector('.grid');
  const mason = document.querySelector('.grid');
  const masonEl = document.getElementsByClassName('grid');

  if (masonEl.length > 0) {
    // var colWidth = $('.grid-item').width();
    $(document).ready(function () {
      imagesLoaded(mason, function () {
        const masonry = new Masonry(grid, {
          itemSelector: '.grid-item',
          percentPosition: true,
          columnWidth: '.grid-sizer',
          gutter: 40,
        });
      });
    });

    const masSlider = $('.masMod__cont');
    const masSliderSettings = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: true,
      touchMove: true,
      arrows: false,
      cssEase: 'ease',
      accessibility: true,
      fade: true,
      arrows: true,
      prevArrow: $('.masMod__prev'),
      nextArrow: $('.masMod__next'),
      infinite: true,
      cssEase: 'ease-in-out',
    };

    if (masSlider) {
      masSlider.slick(masSliderSettings);
      $(window).resize(masSlider.slick('setPosition'));
    }

    let closeSlider = $('.masMod__close');
    let modalSlider = $('.masMod');
    let masonryWrapper = $('.masMod__wrap');
    closeSlider.on('click', function () {
      modalSlider.css('display', 'none');
    });
    masonryWrapper.on('click', function (e) {
      if ($(e.target).hasClass('masMod__wrap')) {
        modalSlider.css('display', 'none');
      }
    });
    let openBtn = $('.masonry__open');
    openBtn.on('click', function () {
      modalSlider.css('display', 'block');
      masSlider.slick('setPosition');
    });

    let gridItem = $('.grid-item');
    gridItem.on('click', function () {
      let slideno = $(this).data('id');
      modalSlider.css('display', 'block');
      masSlider.slick('setPosition');
      masSlider.slick('slickGoTo', slideno);
    });
  }
}
